import React from "react";
//import { batteryToPercent, releaseToPercent } from "helpers";



function voltageToPercentage(voltage: number): number {
	const minVoltage = 136;
	const maxVoltage = 610;
	// Calculate percentage using linear scaling
	const percentage = ((voltage - minVoltage) / (maxVoltage - minVoltage)) * 100;
	// Clamp the result between 0% and 100%
	return Math.round(Math.max(0, Math.min(100, percentage)));
}



const adapter = (item: any) => {
	//return {
	//	battv: item?.battv,
	//	target: item?.target && parseInt(item?.target),
	//	release: item?.release ? item?.release : undefined,
	//	skipped: item?.skipped || item?.skip || (item?.v && item?.v?.skip),
	//	reason: item?.reason || (item?.v && item?.v?.reason),
	//	actualRelease: item?.trel
	//};
	const delivered = item["1"] < (0.3 * item["3"]) ? 1 : 0;
	const target_percentage = voltageToPercentage(item["3"])
	return {
		delivered: delivered,
		target_percentage: target_percentage
	};

};


const SCMaxZapTableRecord: React.FC<any> = (props) => {
	const delivery = adapter(props);
	//const battery = batteryToPercent(zap.battv);
	//const target = parseInt(zap.target);
	//const release = releaseToPercent(zap.release);
	const delivered = delivery.delivered ? "🟢" : "🔴";
	const target_percentage = delivery.target_percentage
	return (
		<>
			⚡{target_percentage}% {delivered}
		</>
	);
};

export default SCMaxZapTableRecord;
